import { useSearchParams } from 'react-router-dom';

/**
 * The filter of a Money tab, kept in the address with the tab so a reload,
 * Back, or a link from the Overview lands on the same list. `fallback` is the
 * filter shown when the address names none.
 */
export function useMoneyFilter(tab: string, fallback: string) {
  const [params, setParams] = useSearchParams();
  const filter = params.has('filter') ? params.get('filter')! : fallback;
  const setFilter = (key: string) => setParams({ tab, filter: key });
  return [filter, setFilter] as const;
}
